export enum QuestionnaireStatus {
    completed = 'completed',
    draft = 'draft',
    opened = 'opened',
}
